import CA_Animation from "./CA_Animation.js";

/**
 * Will increase numbers from 0 to their original value as an animation.
 *
 * @since 1.1.0
 *
 * @author Alexander Uhlemann
 */
export default class CA_FadeAnimation extends CA_Animation {
  /**
   * The constructor takes the config for this animation and
   * calls it's parent class constructor
   *
   * @param { object } config The configurations for the animation
   */
  constructor(config) {
    super("fade-animation", config);
  }

  /**
   * This function is necessary for the Animator, it gets called if the HTMLElement is intersecting
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { HTMLElement } element The element which intersects and should be animated
   * @param { string } scrollDirection Contains the direction the user was scrolling when the element got intersected. Is either "down" or "up".
   *
   * @returns { void }
   */
  animate = (element, scrollDirection) => {
    // Get the duration for the animation from the dataset
    let duration = element.dataset.caDuration;

    let delay = element.dataset.caDelay;

    // Set the transition duration style for it, and we only have to set it once, thats why we are doing it inside the if
    element.style.transitionDuration = duration + "ms";

    // Set the transition delay style for it, and we only have to set it once, thats why we are doing it inside the if
    element.style.transitionDelay = delay + "ms";

    // Get the classes which should get removed to trigger the animation
    let toDelete = element.dataset.caRemove;

    // If no classes exist, return
    if (!toDelete) return;

    // Otheriwse delete those classes
    this.removeClass = toDelete.trim().split(",");

    // Remove the classes to trigger the animation
    element.classList.remove(...this.removeClass);
  };

  /**
   * This function gets called by the Animator, when the element is out of sight and we can prepare for the next animation
   *
   * @since 1.1.0
   *
   * @author Alexander Uhlemann
   *
   * @param { HTMLElement } element The element which was intersecting and should now be prepared
   * @param { string } scrollDirection Contains the direction the user was scrolling when the element got out of sight. Is either "down" or "up".
   *
   * @returns { void }
   */
  prepareForNextIntersecting = (element, scrollDirection) => {
    if (this.removeClass) {
      element.classList.add(...this.removeClass);
    }
  };
}
